import React, { useState } from 'react'
import TWControls from '../controls/TWControls'
import { Form } from '../controls/useForm'

const PortfolioDeletePopup = ({ deletePortfolio, portfolio }) => {
	const [inputValue, setInputValue] = useState('')

	const submitHandler = e => {
		e.preventDefault()
		deletePortfolio(portfolio)
	}

	const isMatch = inputValue.trim() === portfolio.assetName

	return (
		<Form
			onSubmit={submitHandler}
			className="flex flex-col items-center justify-center text-center"
		>
			<h2 className="text-2xl text-red-500 font-semibold pb-2">WARNING!</h2>
			<p className="text-lg text-red-500 pb-2">Deleted portfolios are not recoverable!</p>
			<p className="text-lg pb-4">
				This will delete this portfolio and all associated notes, partner relationships, tasks,
				files and images.
			</p>
			<label className="text-sm pb-1" htmlFor="portfolio-delete-input">
				Enter the name of the portfolio you wish to delete:
			</label>
			<input
				id="portfolio-delete-input"
				type="text"
				className="border border-gray-300 rounded px-3 py-2 mb-4 w-72 text-center"
				value={inputValue}
				onChange={e => setInputValue(e.target.value)}
				autoComplete="off"
			/>
			{isMatch && (
				<TWControls.Button
					color="error"
					size="small"
					type="submit"
					text="Delete Portfolio"
					className="mt-2"
				/>
			)}
		</Form>
	)
}

export default PortfolioDeletePopup
